import { Alert, Button } from "react-bootstrap";
import { Card, Maker, toolingError } from "../../api/tooling";

export const DeleteCross = () => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const ApprovalBadge = ({ card }: { card: Card }) => (
  <span
    className={`tool-approval ${
      card.approved && !card.deletion_pending && !card.is_deleted
        ? "is-approved"
        : "is-pending"
    }`}
  >
    {card.is_deleted
      ? "Card deleted"
      : card.deletion_pending
      ? "Deletion approval pending"
      : card.approved
      ? "Card approved"
      : "Approval pending"}
  </span>
);

export const ErrorNotice = ({
  error,
  retry,
}: {
  error: unknown;
  retry?: () => void;
}) =>
  error ? (
    <Alert variant="danger" role="alert">
      {toolingError(error)}{" "}
      {retry && (
        <Button variant="outline-danger" size="sm" onClick={retry}>
          Retry
        </Button>
      )}
    </Alert>
  ) : null;
export const MakerBadge = ({ maker }: { maker: Maker }) => (
  <span className="tooling-maker">
    <span className="tooling-dot" style={{ backgroundColor: maker.color }} />
    {maker.name}
  </span>
);
export const dateLabel = (date: string | null) =>
  date
    ? new Date(date).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
    : "—";
